import * as React from "react";
import Select from "@8x8/oxygen-select";

const TaggedSelect = (props) => {
  const {
    taggedValues,
    placeholder,
    hasError,
    options,
    isClearable,
    htmlId,
    onSelectionChanged,
    ...other
  } = props;

  const [input, setInput] = React.useState("");
  const [selectedTags, setSelectedTags] = React.useState([]);
  const [allPossibleTags, setAllPossibleTags] = React.useState(options ?? []);

  // Make sure that the options for this select are all the given options
  // plus any that have been created
  React.useEffect(() => {
    let allTags = [...allPossibleTags];
    for (const tag of selectedTags) {
      if (!allTags.includes(tag)) {
        allTags.push(tag);
      }
    }
    setAllPossibleTags(allTags);
  }, [options, selectedTags]);

  const onTagsChanged = (tags) => {
    setSelectedTags(tags);
  };

  const onKeyDownEvent = (event) => {
    // Nothing to do if no value is currently entered
    if (!input) {
      return;
    }

    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
      setSelectedTags([...selectedTags, { label: input, value: input }]);
      setInput("");
    }
  };

  React.useEffect(() => {
    onSelectionChanged && onSelectionChanged(selectedTags);
  }, [selectedTags]);

  return (
    <Select
      {...other}
      placeholder={placeholder}
      hasError={hasError ?? false}
      isClearable={isClearable ?? false}
      value={selectedTags}
      options={allPossibleTags}
      onChange={onTagsChanged}
      testId={htmlId}
      id={htmlId}
      inputValue={input}
      onInputChange={(inputValue) => setInput(inputValue)}
      onKeyDown={onKeyDownEvent}
      isMulti
      isCreatable
    />
  );
};

export default TaggedSelect;
